import { Multilingual, Organisation, OrganisationList } from "../../../common/types";

export const filteringOrganisationsByLocale = (organisations: OrganisationList[], primaryLocale: string) => {
  let result = new Array<Organisation>();
  organisations.forEach(organisation => {
    let validOrgByLocale: Multilingual | undefined = organisation.multilingual.find(
      org => org.locale.toLowerCase() === navigator.language.toLowerCase()
    );
    if (!validOrgByLocale)
      validOrgByLocale = organisation.multilingual.find(org => org.locale.toLowerCase() === primaryLocale.toLowerCase());
    if (!validOrgByLocale && organisation.multilingual[0]) validOrgByLocale = organisation.multilingual[0];
    if (validOrgByLocale) {
      result.push({
        id: organisation.id,
        organisationId: organisation.organisationId,
        locale: validOrgByLocale.locale,
        companyName: validOrgByLocale.displayName?.trim(),
        addressLine1: validOrgByLocale.addressLine1?.trim(),
        city: validOrgByLocale.city?.trim(),
        postcode: validOrgByLocale.postcode?.trim(),
        countryCode: validOrgByLocale.countryCode?.trim(),
        stateProvince: validOrgByLocale.stateProvince?.trim(),
        logoUrl: validOrgByLocale.logoUrl,
        exhibitorType: organisation.exhibitorType,
        stands: organisation.stands,
        parentId: organisation.parentId
      });
    }
  });
  return result;
};
